import { createBrowserRouter } from "react-router-dom";
import Home from "../pages/Home/Home";
import Main from './../layout/Main/Main';
import Blog from './../pages/Blog/Blog';
import ProjectDetail from "../pages/ProjectDetail/ProjectDetail";

const router = createBrowserRouter([
  {
    path: '/',
    element: <Main />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/blog',
        element: <Blog />,
      },
      {
        path: '/project/:id',
        element: <ProjectDetail />,
      },
    ]
  }
])

export default router;